import api from './api';

export const addExtraPayment = async (obj) => {
    try {
        const response = await api.post('/api/overtime/addExtraPayment', obj);
        return response.data;
    } catch (error) {
        return { result: false };
    }
};